export type TransferDocKind =
  | 'director_letter'
  | 'directors_resolution'
  | 'members_resolution'
  | 'share_transfer_form_corporate'
  | 'share_transfer_form_individual'
  | 'unknown';

function trim(v: unknown): string {
  return v === null || v === undefined ? '' : String(v).trim();
}

export function classifyTransferDoc(input: {
  docCode?: unknown;
  templateName?: unknown;
}): TransferDocKind {
  const code = trim(input.docCode).toUpperCase();
  if (code === 'PRS050') return 'director_letter';
  if (code === 'PRS051') return 'directors_resolution';
  if (code === 'PRS052') return 'members_resolution';
  if (code === 'PRS053') return 'share_transfer_form_corporate';
  if (code === 'PRS054') return 'share_transfer_form_individual';

  const name = trim(input.templateName).toLowerCase();
  if (!name) return 'unknown';
  if (/director\s*letter/.test(name) && /transfer/.test(name)) return 'director_letter';
  if (/director/.test(name) && /resolution/.test(name) && /transfer/.test(name)) {
    return 'directors_resolution';
  }
  if (/(member|shareholder)/.test(name) && /resolution/.test(name) && /transfer/.test(name)) {
    return 'members_resolution';
  }
  if (/corporate\s*transferor/.test(name)) return 'share_transfer_form_corporate';
  if (/individual\s*transferor/.test(name)) return 'share_transfer_form_individual';
  if (/share\s*transfer\s*form/.test(name) && /corporate/.test(name)) {
    return 'share_transfer_form_corporate';
  }
  if (/share\s*transfer\s*form/.test(name) && /individual/.test(name)) {
    return 'share_transfer_form_individual';
  }
  return 'unknown';
}
